import { createAsyncThunk } from '@reduxjs/toolkit';
import { AsyncThunkConfig } from '../../../async-thunk-config';
import { HomeError } from '../home-types';
import mifidSurveyRepository from '../../../../repositories/onboarding-self/mifid-survey-repository';
import { QuestionnaireMifidResponse } from '../../../../api/generated/prometeia';
import {
  FormThematicAreaResponse,
  PostMifidExternalResponse,
  SurveyRisposte,
} from '../../../../api/generated/dob';
import {
  MifidImage,
  MifidSurveyRequest,
} from './home-onboarding-self-mifid-survey-types';
import apiManager from '../../../../api/api-manager';
import { getAPIRequestHeaders } from '../../../../utils/api-utils';

export const getMifidPfSurvey = createAsyncThunk<
  QuestionnaireMifidResponse,
  string,
  AsyncThunkConfig<HomeError>
>('get-mifid-pf-survey', async (customerCode: string, thunkApi) => {
  try {
    return await mifidSurveyRepository.getMifidSurvey(customerCode);
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

export const writeMifidPfSurvey = createAsyncThunk<
  PostMifidExternalResponse,
  MifidSurveyRequest,
  AsyncThunkConfig<HomeError>
>('write-mifid-pf-survey', async (request: MifidSurveyRequest, thunkApi) => {
  try {
    return await mifidSurveyRepository.writeMifidSurvey(
      request.customerCode,
      request.writeQuestionnaireMifidRequest,
      thunkApi
    );
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

export const writeMifidNoProfiling = createAsyncThunk<
  SurveyRisposte,
  SurveyRisposte,
  AsyncThunkConfig<HomeError>
>('write-mifid-no-profiling', async (request: SurveyRisposte, thunkApi) => {
  try {
    return await mifidSurveyRepository.writeMifidNoProfiling(request, thunkApi);
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

export const getMifidPfThematicSurvey = createAsyncThunk<
  FormThematicAreaResponse,
  void,
  AsyncThunkConfig<HomeError>
>('get-mifid-pf-thematic-survey', async (_, thunkApi) => {
  try {
    const response = await apiManager.dobSurveyApi.getTemplateExternal(
      'MIFID_PF',
      getAPIRequestHeaders(thunkApi)
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

export const getMifidImage = createAsyncThunk<
  MifidImage,
  string,
  AsyncThunkConfig<HomeError>
>('get-mifid-image', async (imageKey: string, thunkApi) => {
  try {
    const image = await mifidSurveyRepository.getMifidImage(imageKey, thunkApi);
    return {
      imageKey,
      content: image,
    };
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});
